"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createDeliveryTemplate = createDeliveryTemplate;
exports.deleteDeliveryTemplate = deleteDeliveryTemplate;
exports.getDeliveryTemplateInfo = getDeliveryTemplateInfo;
exports.getDeliveryTemplateList = getDeliveryTemplateList;
exports.updateDeliveryTemplate = updateDeliveryTemplate;
var _requestMapi = _interopRequireDefault(require("@/utils/requestMapi"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 获取分页配送模板
 * @param params
 */
function getDeliveryTemplateList(params) {
  return (0, _requestMapi.default)({
    url: '/mapi/user/admin/merchantShippingTemplate/list',
    method: 'get',
    params: params
  });
}

/**
 * 获取配送模板详情
 * @param id
 */
function getDeliveryTemplateInfo(id) {
  return (0, _requestMapi.default)({
    url: '/mapi/user/admin/merchantShippingTemplate/info',
    method: 'get',
    params: {
      id: id
    }
  });
}

/**
 * 新增运费模板
 * @param data
 */
function createDeliveryTemplate(data) {
  return (0, _requestMapi.default)({
    url: '/mapi/user/admin/merchantShippingTemplate/save',
    method: 'post',
    data: data
  });
}

/**
 * 编辑运费模板
 * @param data
 */
function updateDeliveryTemplate(data) {
  return (0, _requestMapi.default)({
    url: '/mapi/user/admin/merchantShippingTemplate/update',
    method: 'post',
    data: data
  });
}

/**
 * 删除运费模板
 * @param id
 */
function deleteDeliveryTemplate(id) {
  return (0, _requestMapi.default)({
    url: '/mapi/user/admin/merchantShippingTemplate/delete',
    method: 'get',
    params: {
      id: id
    }
  });
}